
<div v-if="isAdmin">
  <h3>{{$t('launch.tab.control.heading.show_in_marketplace')}}</h3>
  <cvt-switch
    size="sm"
    color="active"
    type="circular"
    description-type="default"
    :initial-state="marketplace"
    :mode="mode"
    @switchToggle="onSwitchToggle"
  />
</div>
